export const DOCUMENT_STATUS_CONFIG: Record<
  string,
  { color: "default" | "warning" | "success" | "error" }
> = {
  Draft: { color: "warning" },
  Preliminary_approval: { color: "warning" },
  Preliminary_x0020_approval: { color: "warning" },
  Approved: { color: "success" },
  Rejected: { color: "error" },
};